/**
 * Redux Store Configuration for MVP
 */
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './redux/auth/authSlice';
import tabRegistryReducer from './redux/tabRegistry/tabRegistrySlice';
import tabUseReducer from './redux/tabUse/tabUseSlice';
import diagnosticsReducer from './redux/diagnostics/diagnosticsSlice';
import chatReducer from './redux/chat/chatSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        tabRegistry: tabRegistryReducer,
        tabUse: tabUseReducer,
        diagnostics: diagnosticsReducer,
        chat: chatReducer,
        // Add other reducers as needed
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types
                ignoredActions: ['auth/login/fulfilled'],
            },
        }),
});

// Expose store to window for debugging (all environments for now)
(window as any).store = store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
